<template>
  <div class="positionBtnHeader" v-if="shouldShowButtons">
    <div class="d-flex justify-end">
      <v-btn
        v-if="isFollow"
        class="text-none"
        color="#E0E0E0"
        elevation="0"
        @click="setUnfollow()"
      >
        {{ $gettext("Unfollow") }}
      </v-btn>
      <v-btn
        v-else
        color="primary"
        class="elevation-0 text-none"
        depressed
        @click="setFollow()"
      >
        <v-icon class="fal fa-plus pr-3" size="16"></v-icon>
        {{ $gettext("Follow") }}
      </v-btn>
      <v-btn
        class="text-none ml-2 customButtonTabRight" elevation="0" color='primary'
        @click="sendRequestFriend()"
        v-if="canSendRequest"
      >
        <v-icon class="fas fa-comment-dots mr-2" size="15"></v-icon>
        {{ $gettext('Send an invitation') }}
      </v-btn>
      <v-btn
        class="text-none ml-2 customButtonTabRight" elevation="0" color='primary'
        disabled
        v-if="isRequestSent"
      >
        <v-icon class="fas fa-comment-dots mr-2" size="15"></v-icon>
        {{ $gettext('Invitation send') }}
      </v-btn>
      <v-btn
        class="text-none ml-2" elevation="0" color='primary'
        v-if="isRequestPending"
        @click="$store.dispatch('chat/openChatBox', profile.id)"
      >
        <v-icon class="fas fa-comment-dots mr-2" size="15"></v-icon>
        {{ $gettext('Request awaiting') }}
      </v-btn>
      <v-btn
        class="text-none ml-2" elevation="0" color='primary'
        v-if="isFriend"
        @click="$store.dispatch('chat/openChatBox', profile.id)"
      >
        <v-icon class="fas fa-comment-dots mr-2" size="15"></v-icon>
        {{ $gettext('Message') }}
      </v-btn>
      <v-btn
        class="text-none ml-2 customButtonTabRight" elevation="0" color='primary'
        v-if="isBlocking"
        @click="$store.dispatch('chat/openChatBox', profile.id)"
      >
        <v-icon class="fas fa-comment-dots mr-2" size="15"></v-icon>
        {{ $gettext('Unblock user') }}
      </v-btn>
      <v-btn
        class="text-none ml-2" elevation="0" color='primary'
        v-if="isBlockingStranger"
        @click="unblockStranger()"
      >
        <v-icon class="fas fa-comment-dots mr-2 customButtonTabRight" size="15"></v-icon>
        {{ $gettext('Unblock user') }}
      </v-btn>
      <div class="ml-3">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs" v-on="on"
              dark color="#E0E0E0" elevation="0"
            >
              <v-icon class="far fa-ellipsis" size="15" color="black"></v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item class="pl-0">
              <v-list-item-title>
                <v-btn
                  text
                  plain
                  class="text-none mr-2"
                  elevation="0"
                  @click="onReportUser()"
                >
                  <v-icon class="fal fa-circle-exclamation mr-2" size="15"></v-icon>
                  <translate>Report</translate>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="pl-0" v-if="canBlock">
              <v-list-item-title>
                <v-btn
                  text
                  plain
                  class="text-none mr-2"
                  elevation="0"
                  @click="blockUser()"
                >
                  <v-icon class="far fa-user-lock mr-2" size="15"></v-icon>
                  <translate>Block</translate>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>
<script>
import ChatService from "@/services/ChatService";
export default {
  name: "TabsMenuRight",
  props: {
    profile: {
      type: Object,
      default: () => {},
    },
  },
  components: {  },
  data() {
    return {
      isFollow: false,
      isSend: false,
      friend: null
    };
  },
  mounted() {
    if(this.profile) {
    this.friend = this.profile.friend
                  ? JSON.parse(JSON.stringify(this.profile.friend))
                  : null;
    }
    this.isFollow = (this.profile && this.profile.isFollowed) || false;
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    token() {
      return this.$store.state.auth.token;
    },
    shouldShowButtons() {
      return this.profile
              && this.currentUser
              && this.currentUser.id !== this.profile.id
              && !this.isBlocked
    },
    isBlocked() {
      return !!(this.friend
                && (
                    this.friend.status === FRIEND_STATUS_BLOCKED
                    || this.friend.status === FRIEND_STATUS_BLOCKED_STRANGER
                    )
                )
    },
    isBlocking() {
      return !!(this.friend
                && this.friend.status === FRIEND_STATUS_BLOCKING
                )
    },
    isBlockingStranger() {
      return !!(this.friend
                && this.friend.status === FRIEND_STATUS_BLOCKING_STRANGER
                )
    },
    isRequestSent() {
      return !!(this.friend
                && this.friend.status === FRIEND_STATUS_REQUESTED)
    },
    isRequestPending() {
      return this.friend
             && this.friend.status === FRIEND_STATUS_PENDING
    },
    isFriend() {
      return this.friend
             && this.friend.status === FRIEND_STATUS_ACCEPTED
    },
    canSendRequest() {
      return !this.isBlocked && (!this.friend || this.friend.status === FRIEND_STATUS_DENIED)
    },
    canBlock() {
      return !this.friend
              || !(
                    this.friend.status === FRIEND_STATUS_BLOCKING
                    || this.friend.status === FRIEND_STATUS_BLOCKED
                    || this.friend.status === FRIEND_STATUS_BLOCKING_STRANGER
                    || this.friend.status === FRIEND_STATUS_BLOCKED_STRANGER
                  )
    },
    friendState() {
      if(!this.profile) return null
      return this.$store.state.chat.friends.find(f => f.user.id === this.profile.id)
    }
  },
  watch: {
    friendState: {
      handler(value) {
        this.friend = value
      },
      deep: true
    },
    friend() {
      if((this.friend && this.friend.status === FRIEND_STATUS_BLOCKED)
        || (this.friend && this.friend.status === FRIEND_STATUS_BLOCKED_STRANGER)) {
        this.isFollow = false
      }
    }
  },
  methods: {
    async sendRequestFriend() {
      if(!this.token) {
        await this.confirmToken()
      } else {
        const result = await this.$store.dispatch(
          'chat/requestFriend',
          { friend: this.profile.id }
        )
        if(result.error) {
          this.$toast.alert(result.error.message)
        } else {
          this.isSend = true
        }
      }
    },
    async onReportUser() {
      if (!this.token) {
        await this.confirmToken()
      } else {
          this.$store.dispatch("setReport", {
          entityId: this.profile.id,
          entityName: "user",
        });
      }

    },
    async setFollow() {
      if (!this.token) {
        await this.confirmToken()
      } else {
        if (this.currentUser.id) {
          const result = await this.$store.dispatch(
            "follow/setFollow",
            this.profile
          );
          if (result.error) {
            this.$toast.alert(result.error.message);
          } else {
            this.$store.dispatch("setTotalFollowing", +1); //set +/- Following
            this.isFollow = true;
          }
        } else {
          this.$router.push({ name: "login" });
        }
      }
    },
    async setUnfollow() {
      const input = {
        entityId: this.profile.id,
        entityName: this.profile.address ? "course" : "user",
      };
      const result = await this.$store.dispatch("follow/setUnFollow", input);
      if (result.error) {
        this.$toast.alert(result.error.message);
      } else {
        this.$store.dispatch("setTotalFollowing", -1); //set +/- Following
        this.isFollow = false;
      }
    },
    async blockUser() {
      if (!this.token) {
        await this.confirmToken()
      } else {
        const result = await ChatService.blockFriend(this.profile.id);
        this.$store.commit('chat/commitFriend', result.myFriend)
        this.$store.state.toggle.ChatFixedBottom.sendData({
          type: 'blockFriend',
          payload: result.theirFriend
        }, this.profile.id)
      }
    },
    async unblockStranger() {
      let result = await ChatService.unblockFriend(this.profile.id);
      this.$store.commit('chat/removeFriend', this.profile.id)
      this.$store.state.toggle.ChatFixedBottom.sendData({
        type: 'removeFriend',
        payload: this.$store.state.auth.userId
      }, this.profile.id)
    },
    async confirmToken() {
      const toggle = await this.$store.state.toggle.dialogConfirm.open(
        this.$gettext("Warning"),
        this.$gettext('You need to login'),
        { color: "warning" }
      );
      if (!toggle) return
      this.$router.push({name: 'login'})
    },
  },
};
</script>
<style scoped lang="scss">
.positionBtnHeader {
  position: absolute;
  top: 8px;
  right: 0;
  z-index: 9;
}
@media screen and (max-width: 1262px) {
  .positionBtnHeader {
    position: initial;
    padding: 16px 0px;
  }
}
</style>